//busDetails, opening Balances, opening Assets, bank,cash acocunts
//sorry this is a view there's not much container here

import * as React from 'react';
import { connect } from 'react-redux';
import { submit, SubmissionError } from 'redux-form';
import { BackHandler, LayoutAnimation } from 'react-native';
//import Reports from "../../stories/screens/Reports";
//import datas from "./data";
//import { fetchList } from "./actions";
import Modal from '../../components/modal';
import styles from './styles';
import Moment from 'moment';
import diff from 'object-diff';
import CalCalDataApi from '../../api/CalCalDataApi';
import { Container, Title, Header, Left, Spinner, Button, Icon, Body, Right, Content, Card, CardItem, List, ListItem, Text, View, Footer } from 'native-base';

import BusForm from '../../forms/busDetails.general';
import Accounts from './accounts';
import Stock from './stock';

//const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));

class SettingsContainer extends React.PureComponent {
	constructor(props) {
		super(props);

		this.state = { haveSetCards: false, isModalVisible: false, editTitle: '', isModalSaving: false };
	}

	componentDidMount() {
		BackHandler.addEventListener('hardwareBackPress', this.onBackPress);
	}

	componentWillUnmount() {
		BackHandler.removeEventListener('hardwareBackPress', this.onBackPress);
	}

	onBackPress = () => {
		//console.log('back settings');
		this.props.navigation.goBack();
		return true;
	};

	handleItem(item) {
		//console.log(item);

		if (!!item.screen) {
			this.props.navigation.navigate(item.screen, item.navParams);
		} else if (item.shortText == 'Accounts') {
			//this is its own separate modal so it can be included in other screens / forms :)
			this.setState({ showAccounts: true });
		} else if (item.text == 'Stock') {
			this.setState({ showStock: true });
		} else {
			//pop up modal with appropriate form.
			LayoutAnimation.configureNext(LayoutAnimation.Presets.spring);
			this.setState({ isModalVisible: true, closing: false, editTitle: item.shortText || item.text });
		}
	}

	async _closeModal() {
		if (this.state.isModalVisible && this.refs.form) {
			//console.log('saving');
			//still there?
			this.setState({ isModalSaving: true });
			const errors = await this.refs.form.submit();
			this.setState({ isModalSaving: false });
			if (!errors) {
				this.setState({ isModalVisible: false });
			} else {
				return errors;
			}
		} else {
			this.setState({ isModalVisible: false });
		}
	}

	onClosing(closing) {
		//console.log('closing', arguments);
		//can we grab the values here and keep them locally?
		//LayoutAnimation.configureNext(LayoutAnimation.Presets.easeInEaseOut);
		this.setState({ closing });
	}

	handleSubmit(values) {
		//actually submits then fires dispatch to update appropriate store
		//diff values with this.props.busDetails or whatever
		const difference = diff(this.props.busDetails, values); //added, deleted, changed, updated (arrays)
		if (Object.keys(difference).length == 0) return false;
		__DEV__ && console.log('SUBITTing', difference);
		return CalCalDataApi.dataUpdate('busDetails', difference, this.props.jwt, res => {
			if (__DEV__) console.log('handleSubmit ', res);
			if (res.success) {
				this.props.dispatch({
					type: 'UPDATE/busDetails', //successful update send UPDATE(d) to store
					difference //IF no JSON returned, trust local changes
				});
				return false;
			} else if (res.validationErrors) {
				console.log('validationErrors ', res.validationErrors);
				throw new SubmissionError(res.validationErrors);
			}
		});
	}

	render() {
		const { props } = this;
		if (props.busDetails && props.years) {
			const calStart = Moment(props.busDetails.accountingStartDate).format('DD/MM/YY');
			const firstYearStart = Moment(props.years[0].accountingStartDate).format('DD/MM/YY');

			var cards = [
				{
					name: 'Business Details',
					kids: [
						{ text: 'About You', note: 'Business name and contact details', icon: 'list-box' },
						{ text: 'Settings', note: 'CalCal general and invoice settings', icon: 'cog' },
						{ text: 'Tax', note: '', icon: 'cut' },
						{ text: 'VAT', note: '', icon: 'basket' }
						//{ text: 'Advanced', note: 'Settings pre-set based on your business type', icon: 'add' }
					]
				},
				{
					name: 'Income and Expenses',
					kids: [
						{ text: 'Expense categories', screen: 'Budgets', navParams: { tab: 0 }, note: 'Add expense types, set monthly budgets', icon: 'cart' },
						{ text: 'Income types', screen: 'Budgets', navParams: { tab: 1 }, note: 'Add income categories, set monthly targets', icon: 'filing' },
						{ text: 'Stock', note: 'Track your stock value', icon: 'cube' }
					]
				},
				{
					name: 'Accounts',
					kids: [{ text: 'Bank and cash accounts', shortText: 'Accounts', note: '', icon: 'card' }]
				}
			];

			if (props.busDetails.taxType == 'ltd') cards[0].kids = cards[0].kids.filter(item => item.text != 'Tax');
			if (!props.vatReg) cards[0].kids = cards[0].kids.filter(item => item.text != 'VAT');
			if (calStart == firstYearStart) cards[1].kids = cards[1].kids.filter(item => item.text != 'Opening Balances');
			this.state.haveSetCards = true;
		}
		//for modal's sake
		if (!cards) return <Spinner />;

		const { closing, showAccounts, showStock } = this.state;

		return (
			<Container style={styles.container}>
				<Accounts show={showAccounts} close={() => this.setState({ showAccounts: false })} />
				<Stock show={showStock} jwt={props.jwt} close={() => this.setState({ showStock: false })} />
				<Modal
					isOpen={this.state.isModalVisible}
					//backButtonClose
					backdropPressToClose={true}
					coverScreen
					swipeThreshold={100}
					onClosingState={closing => this.onClosing(closing)}
					onClosed={() => this._closeModal()}
					style={styles.modalStyle}
					//backdropOpacity={0.7}
					useNativeDriver>
					<Header style={[styles.modalHeader, closing ? { backgroundColor: '#622' } : {}]}>
						<Left>
							<Button transparent onPress={() => this.setState({ isModalVisible: false })}>
								<Icon active name="close" />
							</Button>
						</Left>
						<Body>
							<Title>{closing ? 'CANCEL' : this.state.editTitle}</Title>
						</Body>
						<Right style={{ width: 50, flex: 0 }}>
							{this.state.isModalSaving ? (
								<Spinner />
							) : (
								<Button transparent onPress={() => this._closeModal()}>
									<Icon active name="checkmark" />
								</Button>
							)}
						</Right>
					</Header>

					<Content keyboardShouldPersistTaps={'handled'} style={{ backgroundColor: 'white', flex: 1 }}>
						<BusForm initialValues={this.props.busDetails} onSubmit={this.handleSubmit.bind(this)} accounts={this.props.accounts} ref="form" formType={this.state.editTitle} />
						{false && (
							<Button full bordered style={{}}>
								<Text>Save and close</Text>
							</Button>
						)}
					</Content>
				</Modal>

				<Header>
					<Left>
						<Button transparent onPress={() => this.props.navigation.navigate('Main')}>
							<Icon name="ios-arrow-back" />
						</Button>
					</Left>
					<Body>
						<Title>Settings</Title>
					</Body>
					<Right />
				</Header>
				<Content style={{ backgroundColor: '#f9f9f9' }}>
					{cards.map((card, j) => (
						<Card key={j} style={{ height: 'auto', flex: null }}>
							<View style={{ flexDirection: 'column', width: '100%' }}>
								<CardItem header bordered>
									<Text>{card.name}</Text>
								</CardItem>
								<List style={{ flex: 0 }}>
									{card.kids.map((item, i) => (
										<ListItem icon key={i} onPress={() => this.handleItem(item)} style={{ backgroundColor: 'transparent', marginVertical: 5 }}>
											<Left>
												<Icon active name={item.icon} style={{ color: 'grey' }} />
											</Left>
											<Body>
												<Text>{item.text}</Text>
												<Text note>{item.note}</Text>
											</Body>
											<Right>
												<Icon name="arrow-forward" />
											</Right>
										</ListItem>
									))}
								</List>
							</View>
						</Card>
					))}
				</Content>
			</Container>
		);
	}
}

const mapStateToProps = state => ({
	busDetails: state.globalReducer.busDetails,
	vatReg: state.globalReducer.busDetails.vatRegistered == 1,
	accounts: state.globalReducer.accounts,
	years: state.globalReducer.yrs,
	jwt: state.loginReducer.jwt && state.loginReducer.jwt.token
});
export default connect(mapStateToProps)(SettingsContainer);
